<template>
        <div @click="openCompany" class="search-result-item">
            <div class="clearfix">
                <div class="pull-right">
                    <search-highlight v-if="typeof item.tags !== 'undefined'" :item="item" :hide="false"
                                      name="tags"
                                      :classes="{ 'ais-Highlight' : 'tag label main-tag'}" />
                </div>
                <strong><ais-highlight attribute="name" :hit="item"/></strong>
                <span style="float:right;font-size:10px;margin-top:4px;">{{ item.manager }} </span>
            </div>
            <search-highlight icon="icon-user" :item="item" v-if="typeof item.contacts !== 'undefined' && item.contacts.length" name="contacts"></search-highlight>
            <search-highlight icon="icon-phone" :item="item" v-if="typeof item.numbers !== 'undefined' && item.numbers.length" name="numbers"></search-highlight>
            <search-highlight icon="icon-mail" :item="item" v-if="typeof item.emails !== 'undefined' && item.emails.length" name="emails"></search-highlight>
            <search-highlight icon="icon-domains" :item="item" v-if="typeof item.domains !== 'undefined' && item.domains.length" name="domains"></search-highlight>
            <div class="websites">
                <div v-if="item.websites" v-for="(website, index) in item.websites" :class="'hit-line ' + highlightClass(index)">
                    <i class="icon icon-website"></i> <span v-if="website.name" v-html="item._highlightResult.websites[index].name.value"></span> -
                    <span v-if="typeof website.domain !== 'undefined' && website.domain" v-html="item._highlightResult.websites[index].domain.value"></span>
                    <span v-if="hasKey(index, 'dev_domain')">{{ item._highlightResult.websites[index].dev_domain.value }}</span>
                    <span v-if="typeof website.tags !== 'undefined' &&  typeof item._highlightResult.websites[index].tags !== 'undefined' && typeof website.tags " >
                        <span class="tag label" v-for="tag in item._highlightResult.websites[index].tags.value.split(',')" v-html="tag"></span>
                    </span>
                </div>
            </div>

            <div class="invoices" v-if="item.invoices">
                <div v-for="(invoice, index) in item.invoices" :class="'hit-line ' + highlightInvoiceClass(index)">
                    <i class="icon icon-dollar"></i> <span v-if="invoice.inv_number" v-html="'#' + item._highlightResult.invoices[index].inv_number.value"></span>
                    ({{ formatMoney(invoice.total) }})
                    <span v-if="invoice.tags" v-for="tag in item._highlightResult.invoices[index].tags">
                        <span v-if="tag.value" class="tag label" v-html="tag.value"></span>
                    </span>
                </div>
            </div>
        </div>
</template>
<script>
    import SearchHighlight from "./search/search-highlight"
    import InputTag from "../components/InputTag";

    export default {
        name: 'vue-hit',
        components: {InputTag, SearchHighlight},
        props: {
            item: { default : '' },
        },
        data() {
            return {
                formatMoney: window.formatMoney,
            }
        },
        methods: {
            openCompany() {
                return window.location = '/company/' + this.item.public_id
            },
            hasKey(index, key) {
                return (typeof this.item._highlightResult.websites[index] !== 'undefined' && typeof this.item._highlightResult.websites[index][key] !== 'undefined' && typeof this.item._highlightResult.websites[index][key].value !== 'undefined');
            },
            highlightInvoiceClass(index)
            {
                let count = 0;
                if (typeof this.item._highlightResult.invoices[index] !== 'undefined' && typeof this.item._highlightResult.invoices[index].inv_number !== 'undefined' &&
                    this.item._highlightResult.invoices[index].inv_number.matchLevel !== 'none') {
                    count++;
                }
                /*if (this.item._highlightResult.websites[index].tags.matchLevel === 'none') {
                    count++;
                }*/
                return 'website-matches match-count-' + count;
            },
            highlightClass(index)
            {
                let count = 0;
                if (typeof this.item._highlightResult.websites[index] !== 'undefined') {
                    if (typeof this.item._highlightResult.websites[index].domain !== 'undefined' &&
                        this.item._highlightResult.websites[index].domain.matchLevel !== 'none') {
                        count++;
                    }
                    if (typeof this.item._highlightResult.websites[index].domain !== 'undefined' &&
                        this.item._highlightResult.websites[index].domain.matchLevel !== 'none') {
                        count++;
                    }
                    if (typeof this.item._highlightResult.websites[index].dev_domain !== 'undefined' &&
                        this.item._highlightResult.websites[index].dev_domain.matchLevel !== 'none') {
                        count++;
                    }
                }
                /*if (this.item._highlightResult.websites[index].tags.matchLevel === 'none') {
                    count++;
                }*/
                return 'website-matches match-count-' + count;
            }
        }
    }
</script>
<style>
    .search-result-item .tag {
        font-size: 8px;
        padding: 2px 4px;
    }
    .search-result-item i {
        font-size: 11px;
    }
    .search-result-item .hit-line {
        padding-left: 6px;
    }
    .search-result-item .tag.main-tag {
        font-size: 11px;
        padding: 4px 8px;
    }
    .search-result-item {
        padding: 10px 17px;
        cursor: pointer;
        border-bottom: 1px solid #eee;
    }
    .search-result-item mark {
        padding: 0;
        background-color: #fcf8e3;
    }
    .website-matches {
        display: block;
    }
    .website-matches.match-count-0 {
        display: none;
    }

    .search-result-item:hover {
        background: #eee;
    }
</style>